import React from 'react';
import { Scale, Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Skeleton } from '../../../components/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { EmptyState } from '../../../components/app';
import { BalanceChecksTableProps } from '../types';

const day = (d: string) => d.slice(0, 10).split('-').reverse().join('.');

export function BalanceChecksTable({ checks, isLoading, onDelete, formatMoney }: BalanceChecksTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Дата выписки</TableHead>
          <TableHead className="text-right">Фактический остаток</TableHead>
          <TableHead>Комментарий</TableHead>
          <TableHead className="w-[1%]">
            <span className="sr-only">Действия</span>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          Array.from({ length: 3 }, (_, i) => (
            <TableRow key={i}>
              {Array.from({ length: 4 }, (__, j) => (
                <TableCell key={j}>
                  <Skeleton className="h-4 w-full max-w-28" />
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : checks.length === 0 ? (
          <TableRow className="hover:bg-transparent">
            <TableCell colSpan={4}>
              <EmptyState
                icon={<Scale />}
                title="Остатки по выписке ещё не вводили"
                description="Без Фактического остатка Кассу сверить не с чем."
              />
            </TableCell>
          </TableRow>
        ) : (
          checks.map((check) => (
            <TableRow key={check.id}>
              <TableCell className="whitespace-nowrap tabular-nums">{day(check.date)}</TableCell>
              <TableCell className="whitespace-nowrap text-right font-semibold tabular-nums">
                {formatMoney(check.amount)}
              </TableCell>
              <TableCell className="max-w-xs truncate text-text-2">{check.comment || '—'}</TableCell>
              <TableCell>
                <Button
                  variant="ghost"
                  size="icon-sm"
                  onClick={() => onDelete(check.id)}
                  aria-label="Удалить запись сверки"
                  title="Удалить запись сверки"
                >
                  <Trash2 className="text-neg" />
                </Button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
